import React, { Component } from 'react';
import './index.css';
import { Button, Modal, Input, Table, Badge, Divider, message } from 'antd';
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import NewMerchant from './newMerchant'
import moment from 'moment'
import { 
    actionCreateStore,
    actionUpdateStore,
    actionDeleteStore,
    actionGetStoreList,
    actionOperateStoreFail,
} from '../../../../core/actions/silizhu/store';
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { verifyTelcodeOrEmail } from '../../../../javascripts/generic';
import ClipboardJS from 'clipboard';

interface StateProps {
    orgInfo: any
    storeList: any
    isSuccess: boolean,
    failData: string
}

interface DispatchProps {
    createStore(data) : void
    updateStore(data, formdata, page): void
    deleteStore(id, page): void
    getStoreList(data): void
    clearErrorData(): void
}

const { Search } = Input;

class Index extends Component<StateProps & DispatchProps> {
    
    Columns;
    constructor(props) {
        super(props);
        this.Columns = [
            {
                title: '商户名称',
                dataIndex: 'name',
                key: 'name',
            }, 
            {
                title: '联系方式',
                render: (record) => {
                    let account = record.account || {};
                    return <span>{account.mobileNumber || account.email}</span>
                }
            }, 
            {
                title: '账号状态',
                dataIndex: ['license', 'expireTime'],
                key: 'status',
                render: (text) => {
                    if(text) {
                        let now = (new Date()).valueOf();
                        let end = (new Date(text)).valueOf();
                        return (
                            <div>
                                <Badge status={now < end ? "success" : "error"} /> 
                                {now < end ? "有效" : "无效"}
                            </div>
                        )
                    }
                   
                }
            },
            {
                title: '截止日期',
                dataIndex: ['license', 'expireTime'],
                key: 'expireTime',
                render: (text) => {
                    let end = (new Date(text)).valueOf();
                    let time = moment(+end).format('YYYY-MM-DD HH:mm:ss');
                    return <span>{time}</span>
                }
            },
            {
                title: '操作',
                render : (record) => {
                    return (
                        <div>
                            <a onClick={() => this.copyToClipboard(record.storeCode)}>复制 ID</a>
                            <Divider type="vertical" />
                            <a onClick={() => this.onEdit(record)}>编辑</a>
                            <Divider type="vertical" />
                            <a style={{color: 'red'}} onClick={() => this.onDelete(record.id)}>删除</a>
                        </div>
                    )
                }
            }
        ];
    }

    static getDerivedStateFromProps (props, state) {
        if(props.failData) {
            return {
                confirmLoading: false,
            }       
        }
        else if(props.isSuccess) {
            return {
                confirmLoading: false,
                visible: false,
                data: {}
            }
        }
        return null;
    }

    onEdit = (record) => {
        this.setState({
            data: record,
            visible: true
        })
    }

    copyToClipboard = (text) => {
        const button = document.createElement('button');
        document.body.appendChild(button);

        const clipboard = new ClipboardJS(button, {
            text: () => text,
        });

        clipboard.on('success', () => {
            message.success("复制成功", 2);
            clipboard.destroy();
            document.body.removeChild(button);
        });

        clipboard.on('error', (err) => {
            console.error("复制失败", err);
            message.error("复制失败", 2);
            clipboard.destroy();
            document.body.removeChild(button);
        });

        button.click();
    };

    onDelete = (id) => {
        const { deleteStore } = this.props;
        const { pageNum, pageSize } = this.state;
        Modal.confirm({
            title: "您确定要删除该商户吗？删除后该商户下的所有数据将同步删除！",
            icon: <ExclamationCircleOutlined />,
            content: "",
            okText: "确定",
            okType: 'danger',
            cancelText: "取消",
            onOk() {
                deleteStore(id, {pageNum, pageSize})
            },
            onCancel() {

            }
        })
    }

    componentDidMount () {
        this.props.getStoreList({
            pageNum: 1,
            pageSize: 10,
        });
    }

    state = {
        visible: false,
        confirmLoading: false,
        data: {} as any,
        pageNum: 1,
        pageSize: 10,
    }

    showNewModal = () => {
        this.setState({
            visible: true,
            data: {}
        })
    }

    onCreate = (formdata) => {
        let reg = verifyTelcodeOrEmail(formdata.accountName);
        if(!reg.vaild) {
            return ;
        }
        let sdata = {
            name: formdata.name,
            accountName: formdata.accountName,
            endTime: moment(formdata.time).unix(),
            accountType: reg.type,
        };
        let data = this.state.data;
       if(data && data.id) {
           const { pageSize, pageNum } = this.state;
           data.license.operation = {
               "name": "ORGANIZATION",
               "number": 2
           }
           this.props.updateStore(data, sdata, { pageSize, pageNum });
       }
       else {
            this.props.createStore(sdata);
       }
    }

    onCancel = () => {
        this.setState({
            data: {},
            visible: false,
            confirmLoading: false,
        })
        this.props.clearErrorData();
    }

    onPageChange = (pageNum, pageSize) => {
        this.props.getStoreList({
            pageNum: pageNum,
            pageSize: pageSize,
        })
        this.setState({
            pageNum: pageNum,
            pageSize: pageSize,
        })
    }

    render () {

        const data = this.props.storeList || {};
        let list = data.stores || [];
        let total = +(data.totalElements || '0');

        let orgInfo = this.props.orgInfo || {};
        let disbaleTime = +(orgInfo.expireTime || 0)

        return (
            <div className="merchant model">
                <h3>商户列表</h3>
                <Button 
                    type="dashed" 
                    style={{width: '100%', marginBottom: '30px'}}
                    onClick={() => this.showNewModal()}
                    >+ 创建商户</Button>
                <Table 
                    rowKey={(record) => record.id}
                    dataSource={list} 
                    columns={this.Columns}
                    pagination={{
                        showSizeChanger: true,
                        defaultCurrent: 1,
                        total: total,
                        onChange: this.onPageChange,
                        onShowSizeChange: this.onPageChange,
                        showTotal: total => `总 ${total} 条`
                    }}
                    />
                <NewMerchant 
                    disableTime={disbaleTime}
                    data={this.state.data}
                    visible={this.state.visible}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.onCreate}
                    onCancel={this.onCancel}
                    failData={this.props.failData}
                    />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        storeList: state.silizhuStore.storeList,
        failData: state.silizhuStore.failData,
        isSuccess: state.silizhuStore.isSuccess,
        orgInfo: state.user.orgInfo,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        createStore: (data) => {
            dispatch(actionCreateStore(data))
        },
        getStoreList: (data) => {
            dispatch(actionGetStoreList(data))
        },
        updateStore: (data, formdata, page) => {
            dispatch(actionUpdateStore(data, formdata, page))
        },
        deleteStore: (id, page) => {
            dispatch(actionDeleteStore(id, page))
        },
        clearErrorData: () => {
            dispatch(actionOperateStoreFail({
                data: ''
            }))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)